export default "__VITE_PUBLIC_ASSET__0f4ccc48__"